<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const title = field<string>("title", "");
const subtitle = field<string>("subtitle", "");
const image = field<string>("image", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:image" accent="content">
    <EditorField :label="t('fields.title.label')">
      <Input
        v-model="title"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.title.placeholder')"
        autocomplete="header-title"
      />
    </EditorField>

    <EditorField :label="t('fields.subtitle.label')">
      <Input
        v-model="subtitle"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.subtitle.placeholder')"
        autocomplete="header-subtitle"
      />
    </EditorField>

    <EditorField :label="t('fields.image.label')">
      <EditorPathInput
        v-model="image"
        mode="existing-file"
        :scopes="['site', 'external']"
        allow-http-urls
        content-type-filter="image"
        :placeholder="t('fields.image.placeholder')"
        aria-label="Hero image"
      />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Hero"
  fields:
    title:
      label: "Title"
      placeholder: "Enter a title"
    subtitle:
      label: "Subtitle"
      placeholder: "Enter a subtitle"
    image:
      label: "Image"
      placeholder: "Enter an image URL"
</i18n>
